import { connect, type ConnectedProps } from 'react-redux';
import copy from 'copy-to-clipboard';
import SyntaxHighlighter from 'react-syntax-highlighter';
import { vs } from 'react-syntax-highlighter/dist/esm/styles/prism';
import dedent from 'dedent';
import { WIDGET_URL } from '@/config';
import { openSnackbar } from '@/core/features/snackbar';
import { DrawerLayout } from '../../layouts';
import { type DrawerContentProps } from '../../../state';

type Props = DrawerContentProps & ConnectedProps<typeof connector>;

const EmbedEventDrawer = ({
  closeDrawer,
  drawerData: { eventId },
  openSnackbar,
}: Props) => {
  const code = dedent`
    <div id="sport-widget-feed"></div>
    <script src="${WIDGET_URL}/sport-widget-feed.umd.cjs"></script>
    <script>
      window.renderSportWidgetFeed('sport-widget-feed', {
        eventId: '${eventId}',
      });
    </script>
  `;

  const handleCopy = () => {
    copy(code);
    openSnackbar({
      snackbarMessage: 'Copied to clipboard',
      snackbarType: 'success',
    });
    closeDrawer();
  };

  return (
    <DrawerLayout
      closeDrawer={closeDrawer}
      title="Embed Event"
      onAccept={handleCopy}
      acceptText="Copy"
      onCancel={closeDrawer}
      cancelText="Cancel"
    >
      <SyntaxHighlighter style={vs}>{code}</SyntaxHighlighter>
    </DrawerLayout>
  );
};

const connector = connect(null, {
  openSnackbar,
});

export default connector(EmbedEventDrawer);
